const deleteTypologyMutation = `
  mutation DeleteMarketplaceTypology($id: ID!) {
    deleteMarketplace_typology(input: { id: $id }) {
      marketplace_typology {
        objectId
      }
    }
  }
`
  .replace(/\r?\n|\r/g, "")
  .replace(/\t/g, " ");

export default deleteTypologyMutation;
